import React from "react";

const Guidelines = () => {
  return (
    <div style={{height:'70dvh',overflowY:'auto' ,width:'100%',overflowX:'hidden'}}>
      <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white w-100">
        <h5
          className="modal-title text-white text-capitalize"
          style={{ fontSize: "18px", fontWeight: 400 }}
        >
          Before proceeding with the document, please ensure the following
          guidelines are followed
        </h5>
      </div>
      <div className="row py-3 px-4 ">
        <div className="w-100">
          <div
            className="col-12 p-3"
            style={{ borderBottom: "1px solid #d3d0d0" }}
          >
            <div className="d-flex __custom_row">
              <div style={{ flex: "1 1" }}>
                <h4 className="__custom_heading"> Photo Requirement</h4>
                <ul className="px-4">
                  <li>Recent photo (taken within the last 6 months).</li>
                  <li>
                    Only you should be in the image (no other people or
                    distractions).
                  </li>
                  <li>Portrait orientation (vertical).</li>
                  <li>
                    Plain, neutral-colored background (white, gray, or light
                    blue).
                  </li>
                  <li>
                    Avoid hats, sunglasses, or accessories that obscure your
                    face (unless for cultural or medical reasons).
                  </li>
                  <li>Proper lighting without harsh shadows.</li>
                  <li>No bright, neon, or distracting patterns.</li>
                </ul>
              </div>
              <div className="mb-0" style={{ width: "200px", height: "200px" }}>
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  src="/img/photo_template.png"
                />
              </div>
            </div>
          </div>
          <div
            className="col-12 p-3"
            style={{ borderBottom: "1px solid #d3d0d0" }}
          >
            <div className="d-flex __custom_row">
              <div style={{ flex: "1 1" }}>
                <h4 className="__custom_heading">Signature Requirement</h4>
                <ul>
                  Choose from four easy options: draw with a mouse, upload an
                  image of your signature, or sign with your finger or stylus on
                  a touch screen. The required signature size is 200x67 pixels.
                </ul>
              </div>
              <div className="mb-0" style={{ width: "210px", height: "121px" }}>
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  src="/img/signature_template.png"
                />
              </div>
            </div>
          </div>
          <div
            className="col-12 p-3"
            style={{ borderBottom: "1px solid #d3d0d0" }}
          >
            <div className="d-flex __custom_row">
              <div style={{ flex: "1 1" }}>
                <h4 className="__custom_heading">Cancel cheque Requirement</h4>
                <ul className="pr-2">
                  To make a cancelled cheque, take a fresh cheque from your
                  chequebook, draw two parallel lines across the cheque, and
                  write "CANCELLED" clearly between the lines; do not sign the
                  cheque as it should be unusable for payment purposes; ensure
                  you do not write on the MICR band and dispose of it properly.
                </ul>
              </div>
              <div className="mb-0" style={{ width: "230px", height: "145px" }}>
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  src="/img/check_template.png"
                />
              </div>
            </div>
          </div>
          <div
            className="col-12 p-3"
          >
            <div className="d-flex __custom_row">
              <div style={{ flex: "1 1" }}>
                <h4 className="__custom_heading">Disclaimer</h4>
                <ul className="pr-2">
                  By uploading your photo and signature for digital onboarding,
                  you consent to their use as your legally binding digital
                  identity in all company documents and official processes.
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guidelines;
